import { render, staticRenderFns } from "./contact-communication-form.vue?vue&type=template&id=8b1975ee&"
import script from "./contact-communication-form.vue?vue&type=script&lang=js&"
export * from "./contact-communication-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports